import React, { useState, useRef } from 'react';
import { FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import { useUser } from '../../hooks/useUser';
import { useAuth } from '../../hooks/useAuth';
import { UserProfile } from './UserProfile';
import './Header.css';

interface HeaderProps {
  title?: string;
  children?: React.ReactNode;
  onStartTutorial?: () => void;
  hasNeverCompletedTutorial?: boolean;
  onToggleMenu?: () => void;
  isMenuOpen?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ title = "Fleet Manager", children, onStartTutorial, hasNeverCompletedTutorial, onToggleMenu, isMenuOpen }) => {
  const [showUserProfile, setShowUserProfile] = useState(false);
  const { username } = useUser();
  const { logout } = useAuth();
  const profileRef = useRef<HTMLDivElement>(null);
  const usernameRef = useRef<HTMLSpanElement>(null);

  // El tooltip se muestra/oculta con hover, no necesita click handler

  return (
    <div className="header-top">
      <div className="header-title">
        {/* Botón hamburguesa para móvil */}
        {onToggleMenu && (
          <button 
            className="header-hamburger-button"
            onClick={onToggleMenu}
            title={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        )}
        <img 
          src="/media/logos/fleetmanager-logo.png" 
          alt="Fleet Manager Logo" 
          className="header-logo"
        />
        <h1>{title}</h1>
      </div>
      <div className="header-controls">
        {children}
        <div className="user-info">
          <span 
            ref={usernameRef}
            className="username clickable" 
            onMouseEnter={() => setShowUserProfile(true)}
            onMouseLeave={() => setShowUserProfile(false)}
            title="Ver perfil"
          >
            {username}
          </span>
          {showUserProfile && (
            <div 
              ref={profileRef} 
              className="user-profile-wrapper"
              onMouseEnter={() => setShowUserProfile(true)}
              onMouseLeave={() => setShowUserProfile(false)}
            >
              <UserProfile onClose={() => setShowUserProfile(false)} />
            </div>
          )}
          {onStartTutorial && (
            <button 
              className={`tutorial-button ${hasNeverCompletedTutorial ? 'pulse' : ''}`}
              onClick={onStartTutorial}
              title="Iniciar tutorial"
            >
              Tutorial
            </button>
          )}
          <button 
            className="logout-button"
            onClick={logout}
            title="Cerrar sesión"
          >
            <FaSignOutAlt />
          </button>
        </div>
      </div>
    </div>
  );
}; 